<template>
	<div class="settleIn-container">
		<div class="box mainCont">
			<h2>师傅入驻</h2>
			<el-form :model="form" id="formSet" :rules="rules" ref="setInForm"  class="formBox">
				<el-form-item class="form_item w48" prop="name">
					<p class="laben">姓名</p>
					<div class="item_input">
						<el-input v-model="form.name" placeholder="请输入姓名"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="phone">
					<p class="laben">电话</p>
					<div class="item_input">
						<el-input v-model="form.phone" type="number" :maxlength="11" placeholder="请输入手机号"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="wxNo">
					<p class="laben">微信号</p>
					<div class="item_input">
						<el-input v-model="form.wxNo" placeholder="请输入微信号"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="area">
					<p class="laben">省市区</p>
					
					<div class="item_inputs">
						<!-- 
						:options="optionsThree" -->
						<!-- :show-all-levels="false"  -->
						<el-cascader
						v-model="selectedThree"
						:options="options"
						:props="Props" 
						:key="cascaderKey"
						placeholder="请选择省市区" 
						@change="handleChange"
						ref="three"
						></el-cascader>
						<!-- <el-select v-model="form.province" placeholder="请选择省份" :popper-append-to-body="false" style="margin-right: 5px;">
							<el-option
							  v-for="item in serverList"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="form.city" placeholder="市" :popper-append-to-body="false" style="margin-right: 5px;">
							<el-option
							  v-for="item in serverList"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="form.area" placeholder="区" :popper-append-to-body="false">
							<el-option
							  v-for="item in serverList"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select> -->
					</div>
				</el-form-item>
                <el-form-item label="门店详细地址选点" class="form_item" prop="address">
              <el-input placeholder="请选择门店地址" v-model="addressInfo.address" disabled>
               <template slot="prepend">{{addressInfo.province}}{{addressInfo.city}}{{addressInfo.district}}</template>
               <el-button slot="append" icon="el-icon-map" @click="showMap" type="primary">选择地址</el-button>
             </el-input>
           </el-form-item>


				<!-- <el-form-item class="form_item" prop="address">
					<p class="laben">详细地址</p>
					<div class="item_input">
						<el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
					</div>
				</el-form-item> -->
				<el-form-item class="form_item w48" prop="mobile">
					<p class="laben">手机号</p>
					<div class="item_input">
						<el-input v-model="form.mobile" type="number" :maxlength="11" placeholder="请输入手机号"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="code">
					<p class="laben">验证码</p>
					<div class="item_input">
						<el-input v-model="form.code" placeholder="请输入验证码"></el-input>
						<div class="btn" @click="getVCode()">{{vcodeBtnName}}</div>
					</div>
				</el-form-item>
				<!-- <el-form-item class="form_item" prop="company">
					<p class="laben">服务内容</p>
					<div class="item_input">
						<el-input v-model="address" placeholder="请输入服务内容"></el-input>
					</div>
				</el-form-item> -->
				<el-form-item class="form_item" prop="zmImg">
					<p class="laben">上传身份证正反面</p>
					<div class="upBox">
						<div class="itemAdd">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'zmImg')">
								<img v-if="form.zmImg" :src="form.zmImg" class="img">
								<div v-else class="img_nol">
									<img src="../../../static/settleIn/zm.png" alt="">
									<p>身份证正面</p>
									<div class="ing-add"><i class="iconfont icon-jia"></i></div>
								</div>
							</el-upload>
						</div>
						<div class="itemAdd">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'fmImg')">
								<img v-if="form.fmImg" :src="form.fmImg" class="img">
								<div v-else class="img_nol">
									<img src="../../../static/settleIn/fm.png" alt="">
									<p>身份证背面</p>
									<div class="ing-add"><i class="iconfont icon-jia"></i></div>
								</div>
							</el-upload>
						</div>
					</div>
				</el-form-item>
				<div style="display: flex;">
					<el-form-item class="form_item" prop="yyzzImg">
						<p class="laben">营业执照 <span>（无照请联系平台）</span></p>
						<div class="upBox">
							<div class="itemAdd2">
								<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'yyzzImg')">
									<img v-if="form.yyzzImg" :src="form.yyzzImg" class="img">
									<div v-else class="img_nol">
										<i class="iconfont icon-jia"></i>
									</div>
								</el-upload>
							</div>
						</div>
					</el-form-item>
					<el-form-item class="form_item">
						<p class="laben">资质<span>（无资质上传营业执照）</span></p>
						<div class="upBox">
							<div class="itemAdd2">
								<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'zzImg')">
									<img v-if="form.zzImg" :src="form.zzImg" class="img">
									<div v-else class="img_nol">
										<i class="iconfont icon-jia"></i>
									</div>
								</el-upload>
							</div>
						</div>
					</el-form-item>
				</div>
				<el-form-item class="form_item">
					<p class="laben">门头图<span>（请上传3张门头图）</span></p>
					<div class="upBox">
						<div class="itemAdd2">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'mtzuo')">
								<img v-if="form.mtzuo" :src="form.mtzuo" class="img">
								<div v-else class="img_nol">
									<i class="iconfont icon-jia"></i>
								</div>
							</el-upload>
						</div>
						<div class="itemAdd2">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'mtzhong')">
								<img v-if="form.mtzhong" :src="form.mtzhong" class="img">
								<div v-else class="img_nol">
									<i class="iconfont icon-jia"></i>
								</div>
							</el-upload>
						</div>
						<div class="itemAdd2">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'mtyou')">
								<img v-if="form.mtyou" :src="form.mtyou" class="img">
								<div v-else class="img_nol">
									<i class="iconfont icon-jia"></i>
								</div>
							</el-upload>
						</div>
					</div>
				</el-form-item>
				<el-form-item class="form_item" prop="headImg">
					<p class="laben">师傅免冠照</p>
					<div class="upBox">
						<div class="itemAdd2">
							<el-upload :show-file-list="false" action="1" :limit="1" accept="image/jpeg,image/jpg,image/png" :http-request="({file})=>uploadRequest(file,'headImg')">
								<img v-if="form.headImg" :src="form.headImg" class="img">
								<div v-else class="img_nol">
									<i class="iconfont icon-jia"></i>
								</div>
							</el-upload>
						</div>
					</div>
				</el-form-item>
				<div class="form_item2">
					<div style="display: flex;align-items: center;" @click="flag = !flag">
						<i v-if="flag" class="iconfont icon-xuanze_a col"></i>
						<i v-else class="iconfont icon-xuanze"></i>
						<span>已阅读并同意</span>
					</div>
					<router-link class="a" to="/agreement?type=3">《免责声明协议》</router-link>
					
					<router-link class="a" to="/agreement?type=2">《隐私政策》</router-link>
					
					<router-link class="a" to="/agreement?type=0">《用户协议》</router-link>
				</div>
				
			</el-form>
			<!-- setInForm -->
			<el-button type="primary" class="form_btn" @click="submitForm('setInForm')">提交</el-button>
		</div>
		  <!-- 百度地图位置选择 -->
    <BMapAddressSelect ref="bmapAddressSelect" @confirmMapAddress="confirmMapAddress"></BMapAddressSelect>


	</div>
</template>
<script>
	
import {uploadFile,shifuRuzhu,sendMsgCode,getMemberInfoByMobile,getProvicneCityArea} from '@/api/api'
import { provinceAndCityData, regionData } from "element-china-area-data";


import BMapAddressSelect from './components/BMapAddressSelect';


export default {
	name: 'settleIn',
	 components: {
    BMapAddressSelect
  },
	data() {
		return {
			  // 位置信息
            addressInfo: {},
            // 表单校验
            rules: {},
			val:'',
			serverList: [],//服务分类
			serverVal: '',
			// 省市区级联
			optionsThree: regionData,
			optionsTwo: provinceAndCityData,
			selectedThree: [],
			selectedTwo: [],
			cascaderKey:1,
			options:[],
			Props: {
				lazy: true,
				// checkStrictly: true,
				lazyLoad: (node, resolve) => {
					console.log(node, 'node');
					let { value = 0 } = node;
					const nodes = [];
					getProvicneCityArea({parentId:value}).then(res => {
						console.log(res)
						let list = res.data;
						list.map((item) => {
							let obj = {
								value: item.id,
								label: item.typeName,
								leaf: node.level >=2,
							};
							nodes.push(obj)
						
						});
						resolve(nodes);
					})
				},
			},
			flag:false,
			form:{
				headImg:'',//师傅免冠照
				"address": "",//地址
				"area": "",//区
				"city": "",//市
				"province": "",//省
				"areaId": "",//区
				"cityId": "",//市
				"provinceId": "",//省
				"code": "",//code
				"phone":'',
				"fmImg": "",//身份证反面
				"zmImg": "",//身份证正面
				"lat": "",//纬度
				"lng": "",//经度
				"mobile": "",//手机号
				"mtyou": "",//门头右
				"mtzhong": "",//门头中
				"mtzuo": "",//门头左
				"name": "",//姓名
				"sendId": "",//发送ID
				"wxNo": "",//微信号
				"yyzzImg": "",//营业执照
				"zzImg": "",//资质图片
			},
			rules: {
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
				],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
				],
				wxNo: [
					{ required: true, message: '请输入微信号', trigger: 'blur' },
				],
				area: [
					{ required: true, message: '请选择省市区', trigger: 'blur' },
				],
				address: [
					{ required: true, message: '请输入详细地址', trigger: 'blur' },
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				fmImg: [
					{ required: true, message: '请上传身份证', trigger: 'blur' },
				],
				yyzzImg: [
					{ required: true, message: '请上传营业执照', trigger: 'blur' },
				],
				mtzuo: [
					{ required: true, message: '请上传门头图（请上传3张门头图）', trigger: 'blur' },
				],
				headImg: [
					{ required: true, message: '请上传师傅免冠照', trigger: 'blur' },
				],
			},
			vcodeBtnName:'获取验证码',
			countNum : 120,
			countDownTimer : null,
		};
	},
	mounted() {
	},
	methods: {
         /** 显示地图 */
    showMap() {
      this.$refs.bmapAddressSelect.show();
    },
 
    /** 确认地图地址 */
    confirmMapAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },


		 /**省市区三级联动 */
		 handleChange() {
			// console.log(this.selectedThree);
			// console.log(this.$refs.three.getCheckedNodes()[0]);
			let arr = this.$refs.three.getCheckedNodes()[0].pathLabels
			this.form.province = arr[0];
			this.form.city = arr[1];
			this.form.area = arr[2];
			this.form.provinceId = this.selectedThree[0];
			this.form.cityid = this.selectedThree[1];
			this.form.areaid = this.selectedThree[2];
		},

		// 获取验证码
		getVCode(){
			var myreg=/^[1][0-9]{10}$/;
			if (!myreg.test(this.form.mobile)){
				this.$message({
				message: '请正确填写手机号码',
				type: 'warning'
				});
				return false;
			}
			// 手机号码为 :  this.phoneno
			// vcodeBtnName 可以阻止按钮被多次点击 多次发送 return 会终止函数继续运行
			if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送'){return ;}
			this.vcodeBtnName =  "发送中...";
			// 倒计时
			this.countNum = 60;
			this.countDownTimer = setInterval(function(){this.countDown();}.bind(this), 1000);
			// 与后端 api 交互，发送验证码
			const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
			});
			sendMsgCode({mobile:this.form.mobile}).then(res => {
				loading.close();
				console.log(res)
				if(res.flag){
					this.form.sendId = res.data;
					this.$message(res.msg|| '短信已发送，请注意查收');
					// this.code = res.result
				}else{
					clearInterval(this.countDownTimer);
					this.$message(res.msg);
					this.vcodeBtnName =  "重新发送";
				}
				
			})
		},
		// 倒计时
		countDown(){
			if (this.countNum < 1){
				clearInterval(this.countDownTimer);
				this.vcodeBtnName = "重新发送";
				return ;
			}
			this.countNum--;
			this.vcodeBtnName =  this.countNum + '秒重发';
		},
		// 上传图片
		uploadRequest(file,key){
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
        	const date = new Date();
			const formData = new FormData();
            formData.append('upload', file);
            uploadFile(formData).then((res) => {
				console.log(res)
				loading.close();
				this.form[key] = res.data;
            }).catch(() => {
                this.$message.error('上传失败');
            });
		},
		// 提交
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if(!this.flag){
						this.$message({
						message: '已阅读并同意《平台入驻协议》',
						type: 'warning'
						});
						return false
					}
					getMemberInfoByMobile({mobile:this.form.phone||this.form.mobile,type:'1'}).then(res => {
						if(res.data){
							// 是师傅了，那么就提示他，不要重新入住
							this.$message({
							message: '该手机号已申请入驻师傅了，不要重新提交',
							type: 'warning'
							});

						}else{
							shifuRuzhu(this.form).then(res => {
								if(res.flag){
									this.$message({
										message: res.msg,
										type: 'success'
									});
									this.form = {
										headImg:'',//师傅免冠照
										"address": "",//地址
										"area": "",//区
										"city": "",//市
										"areaId": "",//区
										"cityId": "",//市
										"provinceId": "",//省
										"code": "",//code
										"phone":'',
										"fmImg": "",//身份证反面
										"zmImg": "",//身份证正面
										"lat": "",//纬度
										"lng": "",//经度
										"mobile": "",//手机号
										"mtyou": "",//门头右
										"mtzhong": "",//门头中
										"mtzuo": "",//门头左
										"name": "",//姓名
										"province": "",//省
										"sendId": "",//发送ID
										"wxNo": "",//微信号
										"yyzzImg": "",//营业执照
										"zzImg": "",//资质图片
									};
									this.selectedThree = [];
									this.selectedTwo = [];
									this.flag = false;
								}else{
									this.$message(res.msg);
								}
								
							})
						}
					})
				}
			});
		},
		goDetail(){
			this.$router.push({
			path: '/server/detail',
				query: {
					mallCode: 'M000989'
				}
			})
		},
	},
};
</script>
<style lang="scss">
.settleIn-container{background-color: #F5F8F9;padding-top:24px;
	.box{width: 1012px;background: #FFFFFF;border-radius: 20px;padding: 40px 66px 48px;margin: 26px auto 44px;
		h2{color: #292A2C;font-size: 30px;font-weight: bold;margin-bottom: 30px;}
		.formBox{display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;
			.form_item{width: 100%;margin-bottom: 24px;
				&.w48{width: 48.86%;}
				.laben{color: #1F263F;font-size: 14px;margin-bottom: 8px;
					span{color: #A4A9B7;font-size: 12px;}
				}
				.item_input{position: relative;width: 100%;display: flex;align-items: center;
					.el-select,.el-input{width: 100%;border-radius: 10px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.el-date-editor{width: 100%;border-radius: 10px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.btn{width: 102px;height: 50px;line-height: 50px;text-align: center;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 14px;margin-left: 8px;cursor: pointer;}
				}
				.item_inputs{position: relative;display: flex;align-items: center;justify-content: space-between;
					.el-cascader,.el-select{width: 170px;
						.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
					}
					.el-cascader{width: 100%;}

				}
				.upBox{display: flex;align-items: center;
					.itemAdd{width: 200px;height: 138px;background: #F5F8F9;border-radius: 10px;margin-right: 24px;overflow: hidden;
						.img{width: 100%;height: 100%;border-radius: 10px;}
						.img_nol{width: 200px;height: 138px;padding: 16px;text-align: center;position: relative;
							img{width: 122px;height: 76px;background: #FFFFFF;border-radius: 16px;display: inline-block;}
							p{color: #A4A9B7;font-size: 12px;text-align: center;line-height: normal;}
							.ing-add{position: absolute;left: 0;right: 0;top: 50px;margin: auto;width: 40px;height: 40px;border-radius: 50%;background-color: #97BCFF;
								display: flex;align-items: center;justify-content: space-around;
								i{color: #fff;font-size: 16px;}
							}
						}
					}
					.itemAdd2{width: 150px;height: 150px;background: #F5F8F9;border-radius: 10px;margin-right: 24px;overflow: hidden;
						.img{width: 100%;height: 100%;border-radius: 10px;}
						.img_nol{width: 150px;height: 150px;border-radius: 10px;display: flex;align-items: center;justify-content: space-around;
							i{color: #A4A9B7;font-size: 30px;}
						}
					}
				}
			}
			.form_item2{display: flex;align-items: center;margin-top: 30px;cursor: pointer;
				i{color: #A4A9B7;font-size: 16px;position: relative;top: 2px;
					&.col{color: #2F78FF;}
				}
				span{color: #A4A9B7;font-size: 16px;margin-left: 8px;}
				.a{color: #2F78FF;font-size: 16px;}
			}
		}
		.form_btn{width: 350px;
height: 60px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 16px;margin: 24px auto 0;cursor: pointer;display: block;}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/views/settleIn/index.vue